import React from "react";
import colormap from "colormap";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "../style";

export function generateColorRamp(numColors) {
  return colormap({
    // colormap: "jet",
    // One can use the "jet" colormap, see https://www.karada-good.net/en/ranalytics/r-e483/,
    // but the level 0 should be much lighter, therefore user-defined colormap is used.
    colormap: [
      { index: 0, rgb: [240, 240, 255] },
      { index: 0.125, rgb: [0, 60, 170] },
      { index: 0.375, rgb: [5, 255, 255] },
      { index: 0.625, rgb: [255, 255, 0] },
      { index: 0.875, rgb: [250, 0, 0] },
      { index: 1, rgb: [128, 0, 0] },
    ],

    nshades: numColors,
    format: "hex", // Output format: hex
    alpha: 1, // Full opacity
  });
}
export const howdenWeightedLevels = 18;
const unscaleFactor = 0.5;
const shiftFactor = 1;
// These factors convert 18 integers (0,17) to "1.00-1.49"..."9.50-9.99"

export const InlandFloodNatcatWeightedLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{`${t("riskAssessment.inlandFloodHowdenWeighted")}`}</b>
      </div>

      {generateColorRamp(howdenWeightedLevels)
        .reverse()
        .map((color, index) => (
          <div key={index}>
            <span style={legendItemStyle(color)}></span>
            {((howdenWeightedLevels + shiftFactor - index) * unscaleFactor).toFixed(2)} -{" "}
            {(howdenWeightedLevels + shiftFactor - index) * unscaleFactor + unscaleFactor - 0.01}
          </div>
        ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          Data from RMA and Howden processed by CyStellar
        </span>
      </div>
    </div>
  );
};
